import createReducer from 'shared/createReducer';
import { REQUEST, RECEIVE, RECEIVE_PROMOTED, UPDATE_FILTERS } from '../constants/action_types';
import {isEmpty} from "lodash";

const initialState = {
    optimalles: [],
    promoted: [],
    isFetching: false,
    nextPage: 0,
    reachedEnd: false,
    filters: {
        hike: null,
        theme: null,
        confirmed: null,
        from: null,
        to: null
    }
};

const request = (state) => ({
    ...state,
    isFetching: true,
});

const updateFilters = (state, action) => ({
    ...state,
    filters: action.filters,
    nextPage: 0,
    reachedEnd: false
});

const receive = (state, action) => {
    let result = [];

    if (state.nextPage == 0) {
        // we clean up the list
        result = action.optimalles;
    } else {
        result = [
            ...state.optimalles,
            ...action.optimalles
        ];
    }

    return {
        ...state,
        optimalles: result,
        nextPage: state.nextPage + 1,
        reachedEnd: isEmpty(action.optimalles),
        isFetching: false
    }
};

const receivePromoted = (state, action) => ({
    ...state,
    promoted: action.optimalles,
    isFetching: false
});

const optimalleReducer = createReducer(initialState, {
    [REQUEST]: request,
    [RECEIVE]: receive,
    [UPDATE_FILTERS]: updateFilters,
    [RECEIVE_PROMOTED]: receivePromoted
});

export default optimalleReducer;